import { gql } from '@apollo/client';

export const BasicAddressFragment = gql`
    fragment BasicAddressFragment on Address {
        id
        line1
        line2
        city
        state
        zipCode
    }
`;
